import styled from 'styled-components';

const StyledWarningBox = styled.p`
  border: 1px solid ${(props) => props.theme.colors.primary};
  padding: 16px;
  border-radius: 4px;
  margin-top: 30px;
  margin-bottom: 0;
`;

export default StyledWarningBox;
